<template>
    <div v-if="opcao" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes da Opção da Questão</h4>
        <router-link to="/configuracoes/parametros-avaliacoes/opcoes">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
      <div class="form-content mt-3">
        <FormSection title="Informações da Questão">
          <p><strong>Categoria de Avaliação:</strong> {{ opcao.categoria_nome || 'Não informado' }}</p>
          <p><strong>Bloco da Questão:</strong> {{ opcao.bloco_nome || 'Não informado' }}</p>
          <p><strong>Questão:</strong> {{ opcao.questao || 'Não informado' }}</p>
          <p><strong>Tipo de Dado:</strong> {{ opcao.tipo_dado || 'Não informado' }}</p>
        </FormSection>
        <FormSection title="Opção">
          <p><strong>Resposta:</strong> {{ opcao.opcao }}</p>
          <p><strong>Correta:</strong> {{ opcao.correta }}</p>
          <p><strong>Observação:</strong> {{ opcao.observacao || 'Não informado' }}</p>
        </FormSection>
        <p><strong>Criado em:</strong> {{ formatarData(opcao.criado_em) }}</p>
        <p><strong>Atualizado em:</strong> {{ formatarData(opcao.atualizado_em) }}</p>
      </div>
    </div>
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  
  export default {
    components: { FormSection },
    data() {
      return {
        opcao: null,
      };
    },
    methods: {
      async carregarDetalhesOpcao() {
        try {
          const response = await axios.get(`/configuracoes/parametros-avaliacoes/opcoes/${this.$route.params.id}`);
          this.opcao = response.data;
        } catch (error) {
          console.error("Erro ao carregar os detalhes da opção:", error);
        }
      },
      formatarData(data) {
        if (!data) return "Não informado";
        return new Date(data).toLocaleString();
      },
    },
    mounted() {
      this.carregarDetalhesOpcao();
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  </style>
  